import { render, staticRenderFns } from "./DevelopmentCard.vue?vue&type=template&id=86197b8c"
import script from "./DevelopmentCard.vue?vue&type=script&lang=js"
export * from "./DevelopmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports